
import NavBar from "../../../Admin/Dashboard/NavBar";
import CrawledSessionRecordsTable from "./CrawledSessionRecordsTable";
import ReactProSidebar from "../../../Admin/Dashboard/ReactProSidebar";

export default function CrawlerSessionRecords() {
  return (
    <>
      <div className="container">
        <NavBar />
        <main className="session-main">
          <CrawledSessionRecordsTable />
        </main>
        {/* <CrawledSidebar /> */}
        <ReactProSidebar />
      </div>
    </>
  );
}
